import React, { useState, useEffect } from 'react';
import AddManualExpenseModal from './AddManualExpenseModal';
import { supabase } from '../../lib/supabase';

interface AddManualExpenseModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  businessId: string;
  initialBookingId?: string;
  initialProjectId?: string;
}

export default function AddManualExpenseModalWrapper({
  isOpen,
  onClose,
  businessId,
  initialBookingId,
  initialProjectId,
}: AddManualExpenseModalWrapperProps) {
  const [categories, setCategories] = useState<any[]>([]);

  useEffect(() => {
    if (isOpen && businessId) {
      void fetchCategories();
    }
  }, [isOpen, businessId]);

  const fetchCategories = async () => {
    try {
      const { data, error } = await supabase
        .from('expense_categories')
        .select('*')
        .eq('business_id', businessId)
        .eq('is_active', true)
        .order('order_index');

      if (error) {
        console.error('Error fetching categories:', error);
        return;
      }

      setCategories(data || []);

      if (!data || data.length === 0) {
        const { error: createError } = await supabase.rpc(
          'create_default_expense_categories',
          { p_business_id: businessId },
        );
        if (!createError) {
          const { data: newCategories } = await supabase
            .from('expense_categories')
            .select('*')
            .eq('business_id', businessId)
            .eq('is_active', true)
            .order('order_index');
          setCategories(newCategories || []);
        }
      }
    } catch (error) {
      console.error('Error in fetchCategories:', error);
    }
  };

  return (
    <AddManualExpenseModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={() => {
        onClose();
        window.dispatchEvent(new CustomEvent('expensesUpdated'));
      }}
      businessId={businessId}
      categories={categories}
      onCategoriesChange={fetchCategories}
      initialBookingId={initialBookingId}
      initialProjectId={initialProjectId}
    />
  );
}
